import React from 'react';
import { ArrowUpRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-bone py-12 px-4 md:px-8" data-id="element-199">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-200">
        <div data-id="element-201">
          <img src="https://cdn.magicpatterns.com/uploads/krogWKC6bDwbBogQ4HpBCV/TEFOS_LOGO.png" alt="TEFOS — El bosque es futuro" className="h-12 w-auto mb-4 brightness-0 invert" data-id="element-202" />
          <p className="text-bone/60 text-sm font-light" data-id="element-203">
            © {new Date().getFullYear()} Programa TEFOS · Todos los derechos
            reservados.
          </p>
        </div>

        <div className="flex flex-wrap gap-6 md:gap-12 text-sm font-medium" data-id="element-204">
          <a href="#inicio" className="hover:text-clay transition-colors" data-id="element-205">
            Inicio
          </a>
          <a href="#hitos" className="hover:text-clay transition-colors" data-id="element-206">
            Hitos
          </a>
          <a href="#resultados" className="hover:text-clay transition-colors" data-id="element-207">
            Resultados
          </a>
          <a href="#noticias" className="hover:text-clay transition-colors" data-id="element-208">
            Noticias
          </a>
        </div>

        <div className="flex gap-4" data-id="element-209"></div>
      </div>
    </footer>;
}